/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { SAMPLE_TO_SALE_SCREEN, COMMON } from '../../global/Constants';
import './sample-to-sale.css';
import ViewImage from '../common/ViewImage';
import DataProvider from '../../providers/DataProvider';

class PlotVisitView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: ["../assets/images/krishak-info-img1.png", "../assets/images/krishak-info-img2.png"],
            plotVisitStage: [
                {
                    stage: 30,
                    cropHealth: "Good",
                    remarks: "Remarks go here",
                    images: ["../assets/images/krishak-info-img1.png", "../assets/images/krishak-info-img2.png"]

                },
                {
                    stage: 120,
                    cropHealth: "Good",
                    remarks: "Remarks go here",
                    images: ["../assets/images/krishak-info-img1.png", "../assets/images/krishak-info-img2.png"]

                }
            ],
        }
    }

    getStage = (cropDayId) => {
        const plotVisitStages = DataProvider.getInstance().getPlotVisitStages();
        if (plotVisitStages && plotVisitStages.length > 0) {
            const stage = plotVisitStages.find(item => item.crop_days_id === cropDayId);
            if (stage) {
                return stage?.crop_day;
            }
        }
        return "";
    }

    render() {
        const { plotVisitStage } = this.props;
        //const { plotVisitStage } = this.state;

        if (plotVisitStage != null) {
            return (
                <div className="row">
                    {/* Data 1 Start */}
                    {
                        plotVisitStage.length ?
                            plotVisitStage.map((item, i) => (
                                <div className="col-12 px-sm-3" key={i}>
                                    <div className="row mb-2 mt-2 mt-md-3">
                                        <div className="col-lg-6 col-4">
                                            {SAMPLE_TO_SALE_SCREEN.STAGE_DAT}
                                        </div>
                                        <div className="col-lg-6 col-8">
                                            <span className="d-block font-weight-medium">{this.getStage(item?.crop_days_id)}</span>
                                        </div>
                                    </div>

                                    <div className="row mb-2 mb-md-2 HistoryDetails">
                                        <div className="col-lg-6 col-4">
                                            {SAMPLE_TO_SALE_SCREEN.CROP_HEALTH}
                                        </div>
                                        <div className="col-lg-6 col-8">
                                            <span className="d-block font-weight-medium">{item?.crop_plot_visit_crop_health_title}</span>
                                        </div>
                                    </div>

                                    <div className="row m-md-0">
                                        <hr className="w-100" />
                                    </div>

                                    {/* Remarks Info */}
                                    <div className="row">
                                        {item?.remark !== null & item?.remark.length > 0 ?
                                            <div className="col-md-6 col-12">
                                                <span className="d-flex w-100 align-items-center mt-2 mt-md-3">
                                                    {SAMPLE_TO_SALE_SCREEN.REMARKS}
                                                </span>
                                                <span className="d-flex font-weight-medium mb-2">{item?.remark}</span>

                                                <div className="row m-md-0 d-md-none">
                                                    <hr className="w-100" />
                                                </div>
                                            </div> : null
                                        }

                                        {/* Images Info */}
                                        {
                                            item?.images ?
                                                <div className="col-md-6 col-12">
                                                    <span className="font-weight-medium d-flex w-100 align-items-center mt-2 mt-md-3 mb-2">{COMMON.IMAGES}</span>
                                                    <div className="row row7-5 mb-3">
                                                        {
                                                            item?.images.length ?
                                                                item?.images.map((image, i) => (
                                                                    <ViewImage key={i} image={image.image_url} />
                                                                )) : null
                                                        }
                                                    </div>

                                                    <div className="row m-md-0 d-md-none">
                                                        <hr className="w-100" />
                                                    </div>
                                                </div> : null
                                        }

                                    </div>

                                    <div className="row m-md-0 d-none d-md-flex">
                                        <hr className="w-100" />
                                    </div>

                                </div>
                            )) : null
                    }
                </div>
            )
        } else {
            return null;
        }

    }
}

export default withRouter(PlotVisitView)